import { Box, Flex, Grid, StackProps, VStack } from "@chakra-ui/layout";
import { forwardRef, Image, Text } from '@chakra-ui/react';
import { NarrowIcon } from "@components/Icons/NarrowIcon";
import { WidgetTitle } from "@components/Texts/WidgetTitle/WidgetTitle";
import { Tile, TILE_MODES } from "@components/Tiles/Tile";
import { generateBlogCategoryUrl } from "@core/paths";
import { Link } from "@reach/router";
import React from "react";
import { CarouselProvider } from "../../../Carousel/Carousel";

export const HorizontalWidget = forwardRef<StackProps & { isDate?: boolean }, "div">(({
  category,
  posts,
  mode = TILE_MODES.DESCRIPTIVE_WITHOUT_THUMBNAIL,
  backgroundColor,
  isDate,
  ...rest
}: any) => {
  return (
  <VStack
    alignItems="flex-start"
    gridGap={{ base: 0, md: "32px" }}
    py={{ base: '17px', sm: backgroundColor === 'transparent' ? '0px' : '49px' }}
    mx={{ base: "-15px", sm: "-77px" }}
    px={{ base: '0', md: '77px' }}
    mb={{ base: '0', sm: "60px" }}
    backgroundColor={backgroundColor}
    {...rest}
  >
    <Flex py={{ base: '17px', sm: '0' }} w="100%" gridGap="10px" flexWrap="wrap" alignItems="center" justifyContent="space-between">
      {category.categoryConfig?.logo
        ? <Box as={Link} to={generateBlogCategoryUrl(category.slug, category?.parent?.node?.slug)} cursor="pointer">
          <Image src={category.categoryConfig?.logo?.sourceUrl} alt="" maxH={{ base: '28px', sm: "50px" }} px={{ base: '15px', sm: '0' }} />
        </Box>
        : <Box as={Link} to={generateBlogCategoryUrl(category.slug, category?.parent?.node?.slug)} cursor="pointer"><WidgetTitle mx="0">{category.name}</WidgetTitle></Box>
      }

      <Box textAlign="end" d={{ base: 'none', sm: 'block' }}>
        <Text fontSize={{ base: '12px', sm: "16px" }} as={Link} to={generateBlogCategoryUrl(category.slug, category?.parent?.node?.slug)} color="#222C63">Przejdź do kategorii <NarrowIcon mt="-4px" /></Text>
      </Box>
    </Flex>
    <Box w="100%" pl="5px" d={{ base: "block", sm: "none" }}>
      <CarouselProvider>
        {posts.map(post => (
          <Box key={post.id} w="100%">
            <Tile isDate={isDate} d={{ sm: 'block', base: 'none' }} mode={mode} article={post} />
            <Tile isDate={isDate} d={{ base: 'block', sm: 'none' }} mode={TILE_MODES.SHORT_WITH_THUMBNAIL_WITH_AVATAR_MOBILE} article={post} />
          </Box>
        ))}
      </CarouselProvider>
    </Box>

    <Grid p="0" d={{ base: "none", sm: "grid" }} templateColumns="repeat(4, 1fr)" gridGap="32px">
      {posts.slice(0, 4).map(post => (<Tile isDate={isDate} key={post.id} mode={mode} article={post} />))}
    </Grid>
  </VStack>
)});
